module.exports = __webpack_public_path__ + "static/media/bgba.466e8546.jpg";